import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { showSuccessToast, showAlertToast } from '@medflex/components/stories/Toast';
import useOrganization from '../hooks/useOrganization';
import useUserProfile from '../hooks/useUserProfile';

const PhysicianOrganizationJoinModule = ({ permanentJoinId }) => {
  const { join, isLoading, data, errors } = useOrganization();
  const { loadUserProfile } = useUserProfile();
  const { t } = useTranslation('physician');
  const hasJoinedSuccessfully = !isLoading && data.name;
  const hasError = !isLoading && errors.join;

  useEffect(() => {
    join(permanentJoinId);
  }, []);

  useEffect(() => {
    if (hasJoinedSuccessfully) {
      showSuccessToast(
        t('PhysicianOrganizationJoinModule.success.title', { name: data.name }),
        null,
        { toastId: 'orgaJoinSuccess' },
      );
      loadUserProfile();
    }

    if (hasError) {
      showAlertToast(
        t('PhysicianOrganizationJoinModule.errors.title'),
        t('PhysicianOrganizationJoinModule.errors.text'),
        { toastId: 'orgaJoinFailed' },
      );
    }
  }, [isLoading]);

  if (hasJoinedSuccessfully || hasError) {
    return <Redirect to="/" />;
  }

  return null;
};

PhysicianOrganizationJoinModule.propTypes = {
  permanentJoinId: PropTypes.string.isRequired,
};

export default PhysicianOrganizationJoinModule;
